<template>
  <div class="history">
    <div ref="e2" id="e2"></div>
    <div class="my-table">
      <!-- 表格 -->
      <el-table
        :header-cell-style="{ background: '#EEEEEE', color: '#606266' }"
        :data="tableData"
        style="width: 100%"
        height="500"
        @cell-mouse-enter="oncell"
      >
        <el-table-column fixed prop="date" label="30天内访问次数" width="150">
        </el-table-column>
        <el-table-column prop="d1" label="07-24" width="120"> </el-table-column>
        <el-table-column prop="d2" label="07-25" width="120"> </el-table-column>
        <el-table-column prop="d3" label="07-26" width="120"> </el-table-column>
        <el-table-column prop="d4" label="07-27" width="120"> </el-table-column>
        <el-table-column prop="d5" label="07-28" width="120"> </el-table-column>
        <el-table-column prop="d6" label="07-29" width="120"> </el-table-column>
        <el-table-column prop="d7" label="07-30" width="120"> </el-table-column>
        <el-table-column prop="d8" label="07-31" width="120"> </el-table-column>
        <el-table-column prop="d9" label="08-01" width="120"> </el-table-column>
        <el-table-column prop="d10" label="08-02" width="120">
        </el-table-column>
        <el-table-column prop="d11" label="08-03" width="120">
        </el-table-column>
        <el-table-column prop="d12" label="08-04" width="120">
        </el-table-column>
        <el-table-column prop="d13" label="08-05" width="120">
        </el-table-column>
        <el-table-column prop="d14" label="08-06" width="120">
        </el-table-column>
        <el-table-column prop="d15" label="08-07" width="120">
        </el-table-column>
        <el-table-column prop="d16" label="08-08" width="120">
        </el-table-column>
        <el-table-column prop="d17" label="08-09" width="120">
        </el-table-column>
        <el-table-column prop="d18" label="08-10" width="120">
        </el-table-column>
        <el-table-column prop="d19" label="08-11" width="120">
        </el-table-column>
      </el-table>
      <div
        v-show="showTips"
        class="tips"
        ref="tips"
        :style="{ left: left, top: top }"
      >
        <el-card class="tipsCard">
          <p class="t1">
            <span class="fz12">07-24</span>
            <span @click="xevent" class="el-icon-close"></span>
          </p>
          <ul class="t2">
            <li>
              <span class="redbox"></span>
              <span class="fz12" style="margin-left: 5px">2次</span>
            </li>
            <li>
              <span class="redf">22,471</span> <span class="fz12">人</span>
            </li>
          </ul>
          <ul class="btn3">
            <li class="buleBtn" @click="$router.push({ name: 'memberList' })">
              查看用户列表
            </li>
            <li
              class="buleBtn"
              @click="$router.push({ name: 'newMarketingPlan' })"
            >
              去运营
            </li>
            <li
              class="buleBtn"
              @click="$router.push({ name: 'newMemberGroup' })"
            >
              添加用户分组
            </li>
          </ul>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Chart, registerTheme } from "@antv/g2";
let data3 = [
  { name: "男性", type: 100, val: 0.33 },
  { name: "女性", type: 100, val: 0.33 },
  { name: "未知", type: 100, val: 0.33 },
  { name: "事例四", type: 13, val: 0.13 },
  { name: "事例五", type: 9, val: 0.09 },
];
export default {
  data() {
    return {
      left: "300px",
      top: "100px",
      tableData: [
        {
          date: "1次",
          d1: "4,346（54%）",
          d2: "4,346（54%）",
          d3: "4,346（54%）",
          d4: "4,346（54%）",
          d5: "4,346（54%）",
          d6: "4,346（54%）",
          d7: "4,346（54%）",
          d8: "4,346（54%）",
          d9: "4,346（54%）",
          d10: "4,346（54%）",
          d11: "4,346（54%）",
          d12: "4,346（54%）",
          d13: "4,346（54%）",
          d14: "4,346（54%）",
          d15: "4,346（54%）",
          d16: "4,346（54%）",
          d17: "4,346（54%）",
          d18: "4,346（54%）",
          d19: "4,346（54%）",
        },
        {
          date: "2次",
          d1: "4,346（54%）",
          d2: "4,346（54%）",
          d3: "4,346（54%）",
          d4: "4,346（54%）",
          d5: "4,346（54%）",
          d6: "4,346（54%）",
          d7: "4,346（54%）",
          d8: "4,346（54%）",
          d9: "4,346（54%）",
          d10: "4,346（54%）",
          d11: "4,346（54%）",
          d12: "4,346（54%）",
          d13: "4,346（54%）",
          d14: "4,346（54%）",
          d15: "4,346（54%）",
          d16: "4,346（54%）",
          d17: "4,346（54%）",
          d18: "4,346（54%）",
          d19: "4,346（54%）",
        },
        {
          date: "3次",
          d1: "4,346（54%）",
          d2: "4,346（54%）",
          d3: "4,346（54%）",
          d4: "4,346（54%）",
          d5: "4,346（54%）",
          d6: "4,346（54%）",
          d7: "4,346（54%）",
          d8: "4,346（54%）",
          d9: "4,346（54%）",
          d10: "4,346（54%）",
          d11: "4,346（54%）",
          d12: "4,346（54%）",
          d13: "4,346（54%）",
          d14: "4,346（54%）",
          d15: "4,346（54%）",
          d16: "4,346（54%）",
          d17: "4,346（54%）",
          d18: "4,346（54%）",
          d19: "4,346（54%）",
        },
        {
          date: "4次",
          d1: "4,346（54%）",
          d2: "4,346（54%）",
          d3: "4,346（54%）",
          d4: "4,346（54%）",
          d5: "4,346（54%）",
          d6: "4,346（54%）",
          d7: "4,346（54%）",
          d8: "4,346（54%）",
          d9: "4,346（54%）",
          d10: "4,346（54%）",
          d11: "4,346（54%）",
          d12: "4,346（54%）",
          d13: "4,346（54%）",
          d14: "4,346（54%）",
          d15: "4,346（54%）",
          d16: "4,346（54%）",
          d17: "4,346（54%）",
          d18: "4,346（54%）",
          d19: "4,346（54%）",
        },
        {
          date: "5次",
          d1: "4,346（54%）",
          d2: "4,346（54%）",
          d3: "4,346（54%）",
          d4: "4,346（54%）",
          d5: "4,346（54%）",
          d6: "4,346（54%）",
          d7: "4,346（54%）",
          d8: "4,346（54%）",
          d9: "4,346（54%）",
          d10: "4,346（54%）",
          d11: "4,346（54%）",
          d12: "4,346（54%）",
          d13: "4,346（54%）",
          d14: "4,346（54%）",
          d15: "4,346（54%）",
          d16: "4,346（54%）",
          d17: "4,346（54%）",
          d18: "4,346（54%）",
          d19: "4,346（54%）",
        },
        {
          date: "其它",
          d1: "4,346（54%）",
          d2: "4,346（54%）",
          d3: "4,346（54%）",
          d4: "4,346（54%）",
          d5: "4,346（54%）",
          d6: "4,346（54%）",
          d7: "4,346（54%）",
          d8: "4,346（54%）",
          d9: "4,346（54%）",
          d10: "4,346（54%）",
          d11: "4,346（54%）",
          d12: "4,346（54%）",
          d13: "4,346（54%）",
          d14: "4,346（54%）",
          d15: "4,346（54%）",
          d16: "4,346（54%）",
          d17: "4,346（54%）",
          d18: "4,346（54%）",
          d19: "4,346（54%）",
        },
        {
          date: "6次",
          d1: "4,346（54%）",
          d2: "4,346（54%）",
          d3: "4,346（54%）",
          d4: "4,346（54%）",
          d5: "4,346（54%）",
          d6: "4,346（54%）",
          d7: "4,346（54%）",
          d8: "4,346（54%）",
          d9: "4,346（54%）",
          d10: "4,346（54%）",
          d11: "4,346（54%）",
          d12: "4,346（54%）",
          d13: "4,346（54%）",
          d14: "4,346（54%）",
          d15: "4,346（54%）",
          d16: "4,346（54%）",
          d17: "4,346（54%）",
          d18: "4,346（54%）",
          d19: "4,346（54%）",
        },
      ],
      showTips: true,
      dom: "",
      data3: [
        { name: "男性", type: 100, val: 0.33 },
        { name: "女性", type: 100, val: 0.33 },
        { name: "未知", type: 100, val: 0.33 },
        { name: "事例四", type: 13, val: 0.13 },
        { name: "事例五", type: 9, val: 0.09 },
      ],
    };
  },
  mounted() {
    this.init2();
  },
  watch: {
    //生成提示信息后生成DOM
    dom() {
      this.init3();
    },
    //提示信息数据改变饼图数据改变
    data3() {
      this.init3();
      let all = document.querySelector("#bing").children;
      let first = document.querySelector("#bing").firstElementChild;
      for (let i = 0; i < all.length; i++) {
        if (all[i] == first) {
          all[i].remove();
        }
      }
    },
  },
  methods: {
    //点击表格单元格事件
    oncell(row, column, event, cell) {
      //row:该行的信息
      //column:当前点击列的信息
      //event:获取当前元素
      //cell
      this.left = cell.pageX - 300 + "px";
      this.top = cell.pageY - 800 + "px";
      if(column.label == "30天内访问次数"){
         this.showTips = false;
      }else{
      this.showTips = true;
      }
    },
    //点击X事件
    xevent() {
      this.showTips = false;
    },
    // 图2
    init2() {
      const data = [
        { name: "1次", type: "7-24", val: Math.random() * 1000 },
        { name: "1次", type: "7-25", val: Math.random() * 1000 },
        { name: "1次", type: "7-26", val: Math.random() * 1000 },
        { name: "1次", type: "7-27", val: Math.random() * 1000 },
        { name: "1次", type: "7-28", val: Math.random() * 1000 },
        { name: "1次", type: "7-29", val: Math.random() * 1000 },
        { name: "1次", type: "7-30", val: Math.random() * 1000 },
        { name: "1次", type: "7-31", val: Math.random() * 1000 },
        { name: "1次", type: "8-1", val: Math.random() * 1000 },
        { name: "1次", type: "8-2", val: Math.random() * 1000 },

        { name: "2次", type: "7-24", val: Math.random() * 1000 },
        { name: "2次", type: "7-25", val: Math.random() * 1000 },
        { name: "2次", type: "7-26", val: Math.random() * 1000 },
        { name: "2次", type: "7-27", val: Math.random() * 1000 },
        { name: "2次", type: "7-28", val: Math.random() * 1000 },
        { name: "2次", type: "7-29", val: Math.random() * 1000 },
        { name: "2次", type: "7-30", val: Math.random() * 1000 },
        { name: "2次", type: "7-31", val: Math.random() * 1000 },
        { name: "2次", type: "8-1", val: Math.random() * 1000 },
        { name: "2次", type: "8-2", val: Math.random() * 1000 },
        { name: "3次", type: "7-24", val: Math.random() * 1000 },
        { name: "3次", type: "7-25", val: Math.random() * 1000 },
        { name: "3次", type: "7-26", val: Math.random() * 1000 },
        { name: "3次", type: "7-27", val: Math.random() * 1000 },
        { name: "3次", type: "7-28", val: Math.random() * 1000 },
        { name: "3次", type: "7-29", val: Math.random() * 1000 },
        { name: "3次", type: "7-30", val: Math.random() * 1000 },
        { name: "3次", type: "7-31", val: Math.random() * 1000 },
        { name: "3次", type: "8-1", val: Math.random() * 1000 },
        { name: "3次", type: "8-2", val: Math.random() * 1000 },
        { name: "4次", type: "7-24", val: Math.random() * 1000 },
        { name: "4次", type: "7-25", val: Math.random() * 1000 },
        { name: "4次", type: "7-26", val: Math.random() * 1000 },
        { name: "4次", type: "7-27", val: Math.random() * 1000 },
        { name: "4次", type: "7-28", val: Math.random() * 1000 },
        { name: "4次", type: "7-29", val: Math.random() * 1000 },
        { name: "4次", type: "7-30", val: Math.random() * 1000 },
        { name: "4次", type: "7-31", val: Math.random() * 1000 },
        { name: "4次", type: "8-1", val: Math.random() * 1000 },
        { name: "4次", type: "8-2", val: Math.random() * 1000 },
        { name: "5次", type: "7-24", val: Math.random() * 1000 },
        { name: "5次", type: "7-25", val: Math.random() * 1000 },
        { name: "5次", type: "7-26", val: Math.random() * 1000 },
        { name: "5次", type: "7-27", val: Math.random() * 1000 },
        { name: "5次", type: "7-28", val: Math.random() * 1000 },
        { name: "5次", type: "7-29", val: Math.random() * 1000 },
        { name: "5次", type: "7-30", val: Math.random() * 1000 },
        { name: "5次", type: "7-31", val: Math.random() * 1000 },
        { name: "5次", type: "8-1", val: Math.random() * 1000 },
        { name: "5次", type: "8-2", val: Math.random() * 1000 },
      ];
      const chart = new Chart({
        container: this.$refs.e2,
        autoFit: true,
        height: 400,
      });

      chart.data(data);
      chart.scale("val", {
        nice: true,
      });
      chart.scale("val", {
        min: 0,
        max: 4000,
      });
      chart.tooltip({
        shared: true,
        showMarkers: false,
      });
      chart.axis("type", {
        tickLine: null, // 不显示刻度线
      });

      registerTheme("newTheme", { minColumnWidth: 20, maxColumnWidth: 30 });
      chart.theme("newTheme");

      // 测试部分
      chart.tooltip({
        title: (title, datum) => `计算基准时间 2021-${datum["type"]} 00:00:00`,
        // showCrosshairs: true, // 展示 Tooltip 辅助线
        shared: true,
        showMarkers: false,
        containerTpl: ` <div class="g2-tooltip" style="width:300px;">
    <div  style="display:flex;justify-content:space-between; align-items: center;">
     <div class="g2-tooltip-title" style="margin:10px 0;"></div>
     <div style="font-size:17px;">88,888<span style="font-size:6px;">人</span></div>
    </div>
    <div style="display:flex;justify-content:space-evenly;">
    <div id='bing' ref="bing" class="" style="width:100px;"></div>
    <ul class="g2-tooltip-list" style="width:200px;"></ul>
    </div>
    </div>`, // tooltip 容器模板
        itemTpl: `
                    <div style="margin-bottom: 10px;list-style:none;margin-left:10px;">
                    <span style="background-color:{color};margin-left:30px;" class="g2-tooltip-marker"></span>
                    <span class="g2-tooltip-name" style="margin-left:-5px;">{name}</span>
                    <span class="g2-tooltip-value" style="display: inline-block; float: right; margin-left: 30px;">82,656人(95%)</span>
                    </div>
                `, // 自定义 toolTip 样式
      });

      chart
        .interval()
        .position("type*val")
        .color("name", ["#5B8FF9", "#5AD8A6", "#9270CA", "#F6BD16", "#E6775D"])
        .adjust("stack");

      chart.interaction("active-region");
      chart.render();
      chart.on("mouseenter", () => {
        setTimeout(() => {
          this.dom = this.$refs.e2.children[0].children[1];
        }, 100);
      });
      chart.on("tooltip:change", (e) => {
        const { data } = e;
        this.data3 = data.items.map((i) => {
          return i.data;
        });
      });
      chart.off("mouseenter", () => {});
    },
    //饼图
    init3() {
      let chart = new this.$chart({
        container: "bing",
        autoFit: true,
        width: 300,
        height: 300,
      });
      chart.data(this.data3);

      chart.coordinate("theta", {
        radius: 0.85,
      });

      chart.scale("val", {
        formatter: (val) => {
          val = val * 100 + "%";
          // return val;
        },
      });
      chart.tooltip({
        showTitle: false,
        showMarkers: false,
      });
      chart.legend(false);
      chart.axis(false); // 关闭坐标轴
      const interval = chart
        .interval()
        .adjust("stack")
        .position("val")
        .color("name", ["#5b8ff9", "#5ad8a6", "#9270ca", "#f6bd16", "#e6775d"])
        .label("val", {
          offset: -40,
          style: {
            textAlign: "center",
            shadowBlur: 2,
            shadowColor: "rgba(0, 0, 0, .45)",
            fill: "#fff",
          },
        })
        .tooltip("name*val", (name, val) => {
          val = val * 100 + "%";
          return {
            name: name,
            value: val,
          };
        })
        .style({
          lineWidth: 1,
          stroke: "#fff",
        });
      chart.interaction("element-single-selected");
      chart.render();
    },
  },
};
</script>
<style lang="less">
.history {
  margin-top: 30px;
  .el-table__row {
    border: 0 solid #000;
  }
  .my-table {
    position: relative;
    margin-top: 20px;
    //单独设置表头高度
    .el-table__header tr,
    .el-table__header th {
      padding: 0;
      height: 41px;
    }
    .el-table__header tr,
    .el-table__header th .cell {
      padding: 0;
      font-weight: 500 !important;
    }
    .el-table__row {
      height: 67px;
    }
    .cell {
      text-align: center;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
    //提示框
    .tips {
      width: 185px;
      height: 225px;
      position: absolute;
      top: 146px;
      left: 317px;
      .tipsCard {
        width: 100%;
        height: 100%;
        .t1 {
          display: flex;
          justify-content: space-between;
         align-items: center;
        }
        .redf {
          font-size: 17px;
          color: #ff7f7f;
        }
        .t2 {
          margin-top: 5px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .btn3 {
          margin-top: 20px;
          > li {
            &:nth-child(2) {
              margin-top: 10px;
            }
            &:nth-child(3) {
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
  .g2-tooltip-value {
    margin-left: 0px !important;
  }
  //公共样式区
  .buleBtn {
    width: 144px;
    height: 34px;
    border-radius: 4px;
    border: 1px solid #327eff;
    font-size: 12px;
    color: #327eff;
    line-height: 34px;
    text-align: center;
  }
  .fz12 {
    font-size: 12px;
    color: #333333;
  }
  .redbox {
    display: inline-block;
    width: 7px;
    height: 7px;
    background: #ff7f7f;
    border-radius: 1px;
    transform: translate(0px, -1px);
  }
}
</style>